import { render } from "./ViewPage.vue?vue&type=template&id=fbf67930"
import script from "./ViewPage.vue?vue&type=script&lang=js"
export * from "./ViewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__